import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../components';
import { closeModal, logout } from '../../../redux/actions';
import { pageUrl } from '../../../settings';

const ApiErrorModalLayout = () => {
	const dispatch = useDispatch();
	return (
		<div className="api-error-modal">
			<h3>Nieudane połączenie</h3>
			<p>
				Wystąpił błąd podczas próby połączenia z bazą danych. Spróbuj ponownie za kilka minut lub
				skontaktuj się z administratorem serwisu
			</p>
			<Button
				color="primary text-white"
				onClick={() => {
					dispatch(logout());
					dispatch(closeModal());
					window.open(pageUrl, '_self');
				}}
			>
				Wyjdź
			</Button>
		</div>
	);
};

export default ApiErrorModalLayout;
